<template>
  <div class="sales_volume_wrap">
    <div class="sbook_st_detail">
      <div class="section fill">
        <div class="inner">
          <h3 class="sub_tit">{{ $t('selfbook.saleschart.196') }}</h3>
          <dl class="sales_info_select">
            <dt>{{ $t('selfbook.saleschart.8925') }}</dt>
            <dd class="dd_list">
              <div class="select_area">
                <div
                  class="select_item"
                  :class="{ active: showSelfbookSelect }"
                >
                  <button
                    v-on-clickaway="closeSelfbookSelect"
                    class="select_option gray"
                    @click="toggleSelfbookSelect"
                  >
                    <span class="txt">{{ selectedSelfbook }}</span
                    ><span class="arrow blind">열기</span>
                  </button>

                  <ul class="select_list">
                    <li class="tit">
                      {{ $t('selfbook.saleschart.2273')
                      }}<button type="button" class="select_list_close an_a">
                        <span class="svg_close"></span
                        ><span class="an_t">{{
                          $t('library.deletemodal.close')
                        }}</span>
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        class="list_option"
                        :class="{ active: selectedSelfbook == '전체' }"
                        @click="chooseSelfbook('전체')"
                      >
                        <span>전체</span>
                      </button>
                    </li>
                    <li v-for="(selfbook, id) in selfbooks" :key="id">
                      <button
                        type="button"
                        class="list_option"
                        :class="{ active: selectedSelfbook == selfbook.title }"
                        @click="chooseSelfbook(selfbook.title)"
                      >
                        <span>{{ selfbook.title }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </dd>
            <dt>기간</dt>
            <dd class="dd_year">
              <!-- sale select year : 2021년부터 제공 -->
              <div class="select_area">
                <div class="select_item" :class="{ active: showYearSelect }">
                  <button
                    v-on-clickaway="closeYearSelect"
                    class="select_option gray"
                    @click="toggleYearSelect"
                  >
                    <span class="txt">{{ selectedYear }}</span
                    ><span class="arrow blind">열기</span>
                  </button>

                  <ul class="select_list checkFix">
                    <li>
                      <button
                        type="button"
                        class="list_option"
                        :class="{ active: selectedYear == '전체' }"
                        @click="chooseYear('전체')"
                      >
                        <span>전체</span>
                      </button>
                    </li>
                    <li v-for="(year, idx) in chartData.years" :key="idx">
                      <button
                        type="button"
                        class="list_option"
                        :class="{ active: selectedYear == year }"
                        @click="chooseYear(year)"
                      >
                        <span>{{ year }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </dd>
            <dt>구분</dt>
            <dd class="dd_sale">
              <div class="select_area">
                <div class="select_item" :class="{ active: showFilterSelect }">
                  <button
                    v-on-clickaway="closeFilterSelect"
                    class="select_option gray"
                    @click="toggleFilterSelect"
                  >
                    <span class="txt">{{ selectedFilter }}</span
                    ><span class="arrow blind">열기</span>
                  </button>

                  <ul class="select_list">
                    <li
                      v-for="(filter, idx) in chartData.filters"
                      :key="idx"
                      :class="{ active: selectedFilter == filter }"
                    >
                      <button
                        type="button"
                        class="list_option"
                        @click="chooseFilter(filter)"
                      >
                        <span>{{ filter }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class="section full">
        <div class="inner">
          <div class="sales_info">
            <div class="sales_chart" data-chart-labal="chart-volum-2019">
              <div class="chart_item_name">
                <dl>
                  <dt>{{ $t('selfbook.saleschart.6312') }}</dt>
                  <dd>
                    {{ chartData.salesCount }}
                  </dd>
                  <dt>{{ $t('selfbook.saleschart.685') }}</dt>
                  <dd>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="chartData.salesPrice"
                    />
                  </dd>
                </dl>
              </div>

              <div class="chart_graphic">
                <div class="chart_data_typebar">
                  <div
                    v-for="(month, idx) in chartData.monthlySales"
                    :key="idx"
                    class="chart_data_group"
                  >
                    <div class="chart_data_line">
                      <span
                        >{{ month.count }}{{ $t('common.ui.bookcount') }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="not_data hidden">
                  {{ $t('selfbook.saleschart.3695') }}
                </div>
              </div>

              <div class="chart_data_label">
                <ul>
                  <li>1월</li>
                  <li>2월</li>
                  <li>3월</li>
                  <li>4월</li>
                  <li>5월</li>
                  <li>6월</li>
                  <li>7월</li>
                  <li>8월</li>
                  <li>9월</li>
                  <li>{{ $t('selfbook.saleschart.9224') }}</li>
                  <li>{{ $t('selfbook.saleschart.3709') }}</li>
                  <li>{{ $t('selfbook.saleschart.2853') }}</li>
                </ul>
              </div>

              <div class="guide_txt">
                <p>{{ $t('selfbook.saleschart.5348') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showSelfbookSelect: false,
      showYearSelect: false,
      showFilterSelect: false,
      selectedSelfbook: '전체',
      selectedYear: '전체',
      selectedFilter: '판매금액',

      selfbooks: [
        { title: 'My Selfbook1', id: 1 },
        { title: 'My Selfbook2', id: 2 },
        { title: 'My Selfbook3', id: 3 }
      ]
    }
  },

  computed: {
    ...mapGetters(['getCurrency'])
  },

  methods: {
    // Select Selfbook
    toggleSelfbookSelect() {
      this.showSelfbookSelect = !this.showSelfbookSelect
    },
    closeSelfbookSelect() {
      this.showSelfbookSelect = false
    },
    chooseSelfbook(value) {
      this.selectedSelfbook = value
    },

    // Select Year
    toggleYearSelect() {
      this.showYearSelect = !this.showYearSelect
    },
    closeYearSelect() {
      this.showYearSelect = false
    },
    chooseYear(value) {
      this.selectedYear = value
    },

    // Select Filter
    toggleFilterSelect() {
      this.showFilterSelect = !this.showFilterSelect
    },
    closeFilterSelect() {
      this.showFilterSelect = false
    },
    chooseFilter(value) {
      this.selectedFilter = value
    }
  }
}
</script>

<style lang="scss" scoped></style>
